import { withTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import warning from "./../../../../../src/assets/img/global/confirmModal/warning.svg";
import { compose } from "redux";
import React, { PureComponent } from "react";
// import "./ConfirmInvoiceModalForm.scss";
import { Form } from "react-final-form";
import PropTypes from "prop-types";
import { Field } from "react-final-form";
import BMXTextField from "../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXDatePicker from "../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";

class ConfirmServiceInvoiceModalForm extends PureComponent {
  static defaultProps = {};

  render() {
    const {
      t,
      onSubmit,
      formName,
      mainText,
      contentText,
      initialValues,
      isError,
      setIsError,
      setIsLoading,
      isLoading,
      isCustomFaVatNumber,
    } = this.props;

    const innerOnSubmit = async (e) => {
      setIsLoading(true);
      setIsError(await onSubmit(e));
      setIsLoading(false);
    };

    const validate = (values) => {
      const errors = {};

      if (!values.invoiceNumber) {
        errors.invoiceNumber = t("global:service.errors.invoiceNumber");
      }

      if (!values.invoiceSaveDate) {
        errors.invoiceSaveDate = t("global:service.errors.invoiceSaveDate");
      }

      return errors;
    };

    return (
      <Form
        initialValues={initialValues}
        onSubmit={innerOnSubmit}
        validate={validate}
      >
        {(formProps) => (
          <form
            onSubmit={formProps.handleSubmit}
            className="ConfirmInvoiceModalForm"
            id={formName}
          >
            <Row>
              <Col className="d-flex justify-content-center mt-5 mb-2" md={12}>
                <img className="img" src={warning} alt="Warning logo" />
              </Col>
            </Row>

            <>
              <Row>
                <Col className="title mt-3A mt-2" md={12}>
                  {t(mainText)}
                </Col>
              </Row>
              <Row>
                <Col className="content mb-2" md={12}>
                  {t(contentText)}
                </Col>
              </Row>
            </>

            <>
              <Row className="mb-4">
                <Col xs={6}>
                  <Field
                    name="invoiceSaveDate"
                    label={`${t("global:service.invoiceSaveDate")}`}
                    component={BMXDatePicker}
                    data-cy="invoiceSaveDate"
                  />
                </Col>
                <Col xs={6}>
                  <Field
                    name="invoiceNumber"
                    label={`${t("global:service.invoiceNumber")}`}
                    component={BMXTextField}
                    data-cy="invoiceNumber"
                  />
                </Col>
              </Row>
            </>
          </form>
        )}
      </Form>
    );
  }
}

ConfirmServiceInvoiceModalForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  mainText: PropTypes.string,
  contentText: PropTypes.string,
};

ConfirmServiceInvoiceModalForm.defaultProps = {
  onSubmit: () => {},
  mainText: "global:confirmModal.delete",
  contentText: "global:confirmModal.confirmDeleteText",
};

export default compose(withTranslation())(ConfirmServiceInvoiceModalForm);
